<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Demande de déverrouillage de dossier</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">L'utilisateur "{{ data.userName }}" vous demande de déverrouiller le dossier "{{ data.folderName }}"</p>

            <app-count-down [expirationDate]="timeOutDate" [options]="countDownOptions" (finished)="onFinished()"></app-count-down>

            <p class="question">Voulez-vous le déverrouiller (le dossier sera fermé) ?</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="close()">Non</button>
        <button mat-raised-button class="accent-button" (click)="valid()">Oui</button>
    </mat-card-actions>
</mat-card>
